import { render, staticRenderFns } from "./informationConfirm.vue?vue&type=template&id=24c68b82&scoped=true&"
import script from "./informationConfirm.vue?vue&type=script&lang=js&"
export * from "./informationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./informationConfirm.vue?vue&type=style&index=0&id=24c68b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c68b82",
  null
  
)

export default component.exports